import { styled } from '../jss-style';
import innerTitleStyle from './inner-title';

const useInnerTitleStyle = styled(innerTitleStyle, 'inner-title');
export { innerTitleStyle, useInnerTitleStyle };
export default useInnerTitleStyle;
